import React from 'react';
import Card from '../../ui/Card';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const SpendVsRevenueChart: React.FC = () => {
  const data = [{
    channel: 'Digital',
    spend: 133.7,
    revenue: 457.2,
    roi: 342
  }, {
    channel: 'BTL',
    spend: 113.8,
    revenue: 326.8,
    roi: 287
  }, {
    channel: 'TV',
    spend: 82.5,
    revenue: 202.1,
    roi: 245
  }, {
    channel: 'Print',
    spend: 45.8,
    revenue: 90.7,
    roi: 198
  }, {
    channel: 'Outdoor',
    spend: 38.2,
    revenue: 48.9,
    roi: 128
  }];
  return <Card className="p-6" data-id="element-8096">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-8097">
        Spend vs Revenue Attribution
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-8098">
        Marketing spend and attributed revenue by channel (₹ Lakhs)
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-8099">
        <ComposedChart data={data} data-id="element-8100">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8101" />
          <XAxis dataKey="channel" tick={{
          fontSize: 11
        }} data-id="element-8102" />
          <YAxis yAxisId="left" tick={{
          fontSize: 12
        }} data-id="element-8103" />
          <YAxis yAxisId="right" orientation="right" tick={{
          fontSize: 12
        }} data-id="element-8104" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number, name: string) => {
          if (name === 'ROI') return `${value}%`;
          return `₹${value}L`;
        }} data-id="element-8105" />
          <Legend data-id="element-8106" />
          <Bar yAxisId="left" dataKey="spend" fill="#ef4444" name="Spend" radius={[8, 8, 0, 0]} data-id="element-8107" />
          <Bar yAxisId="left" dataKey="revenue" fill="#10b981" name="Revenue" radius={[8, 8, 0, 0]} data-id="element-8108" />
          <Line yAxisId="right" type="monotone" dataKey="roi" stroke="#3b82f6" strokeWidth={3} name="ROI %" dot={{
          r: 5,
          strokeWidth: 2
        }} data-id="element-8109" />
        </ComposedChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8110">
        <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-8111">
          <div className="text-center" data-id="element-8112">
            <div className="text-gray-600" data-id="element-8113">Total Spend</div>
            <div className="text-xl font-bold text-red-600" data-id="element-8114">
              ₹{data.reduce((sum, d) => sum + d.spend, 0).toFixed(1)}L
            </div>
          </div>
          <div className="text-center" data-id="element-8115">
            <div className="text-gray-600" data-id="element-8116">Total Revenue</div>
            <div className="text-xl font-bold text-green-600" data-id="element-8117">
              ₹{data.reduce((sum, d) => sum + d.revenue, 0).toFixed(1)}L
            </div>
          </div>
          <div className="text-center" data-id="element-8118">
            <div className="text-gray-600" data-id="element-8119">Overall ROI</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-8120">
              {(data.reduce((sum, d) => sum + d.revenue, 0) / data.reduce((sum, d) => sum + d.spend, 0) * 100).toFixed(0)}
              %
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default SpendVsRevenueChart;